<template>
    <div>
        <bankChannelTab>
            <template v-slot="{channelType}">
                <div>
                    <base-list-management
                        v-if="channelType === bankChannelType"
                        ref="baseListManagement"
                        :configData.sync="configData"
                    >
                        <div slot="custom-operate">
                            <el-button
                                type="primary"
                                size="small"
                                @click="addRule"
                                v-if="getAddRulePermission"
                            >
                                新建规则
                            </el-button>
                        </div>
                    </base-list-management>
                </div>
            </template>
        </bankChannelTab>
        <transferRuleDialog
          v-model="ruleDialogModel.show"
          :isEdit="ruleDialogModel.isEdit"
          :ruleId="ruleDialogModel.ruleId"
          :channelType="bankChannelType"
          @submitSucc="refreshList"
        />
        <!-- 启用、停用二次弹窗 -->
        <dialogWrap
            v-model="ruleConfirmDialog.show"
            title="提示"
            width="500px"
        >
        <div>规则停用后将停止下一笔资金的自动转账，是否确认?</div>
        <template slot="footer">
            <el-button size="small" @click="ruleConfirmDialog.show = false">取消</el-button>
            <el-button
                size="small"
                :loading="ruleConfirmDialog.loading"
                type="primary"
                @click="submitConfirmHandle"
            >确认</el-button>
        </template>
        </dialogWrap>
        <!-- 手动转账二次弹窗 -->
        <dialogWrap
            v-model="manualDivideDialog.show"
            title="手动转账"
            width="500px"
        >
            <div>{{ `点击确认后，将立即从 ${manualDivideDialog.transferorName} 向 ${manualDivideDialog.receiverName} 转账 ${manualDivideDialog.divideAmount} 元，操作不可撤回，转账完成后您可以在“交易明细账单”页面查看交易结果，确认执行？` }}</div>
            <template slot="footer">
                <el-button size="small" @click="manualDivideDialog.show = false">取消</el-button>
                <el-button
                    size="small"
                    :loading="manualDivideDialog.loading"
                    type="primary"
                    @click="submitManualDivide"
                >确认</el-button>
            </template>
        </dialogWrap>
    </div>
</template>

<script>
import bankChannelTab from '@/pages/finance/bankChannelTab'
import transferRuleDialog from './transferRuleDialog/index.vue'
// eslint-disable-next-line import/no-cycle
import config from './config'
import { getSuperviseAccountList, modifyDivideRuleStateSignCheck, applyDivide } from '@/api/domain/finance'
import ENUM from '@/pages/finance/partnerAccountOpen/enum'
import { mapGetters } from 'vuex'

export default {
  components: { bankChannelTab, transferRuleDialog },
  data() {
    const { configData } = config.call(this)
    return {
      configData,
      ruleConfirmDialog: {
        show: false,
        loading: false,
        state: '',
        ruleId: '',
      },
      manualDivideDialog: {
        show: false,
        loading: false,
        ruleId: '',
        transferorName: '',
        receiverName: '',
        divideAmount: '',
      },
      ruleDialogModel: {
        show: false,
        isEdit: false,
        ruleId: 0,
      },
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    handleEnableState(row) {
      this.$confirm(
        `今日为本转账规则的转账日，启用后是否立即触发一次转账？点击立即转账后，将从 ${row.transferorName} 向 ${row.receiverName} 转账 ${row.divideAmount} 元，操作不可撤回，转账完成后您可以在“交易明细账单”页面查看交易结果。`,
        '请确认是否立即转账？',
        {
          confirmButtonText: '立即转账',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(async () => {
          const { code, data } = await modifyDivideRuleStateSignCheck({
            ruleId: row.ruleId,
            state: ENUM.STATE_ENUM.enable,
            channelType: this.bankChannelType,
          })
          if (code === 1) {
            if (data.result) {
              this.$message.success(`${row.transferorName} 向 ${row.receiverName} 转账中，金额${row.divideAmount} 元`)
            } else {
              this.$message.error(data.info)
            }
            this.$refs.baseListManagement.searchForm()
          }
        }).catch(() => null)
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleDisableState(row) {
      this.ruleConfirmDialog = {
        state: ENUM.STATE_ENUM.disable,
        ruleId: row.ruleId,
        show: true,
        loading: false,
      }
    },
    addRule() {
      this.ruleDialogModel.show = true
      this.ruleDialogModel.isEdit = false
    },
    // eslint-disable-next-line vue/no-unused-properties
    editRule(row) {
      this.ruleDialogModel = {
        show: true,
        isEdit: true,
        ruleId: row.ruleId,
        channelType: this.bankChannelType,
      }
    },
    refreshList() {
      this.$refs.baseListManagement.searchForm()
    },
    async getReceiverAndTransferAccountList(types) {
      const { code, data } = await getSuperviseAccountList({
        type: types,
        channelType: this.bankChannelType,
        filterDisabled: true,
      })
      if (code === 1) {
        setTimeout(() => {
          this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'transferorId', data: data.transferorList })
          this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'receiverId', data: data.receiverList })
        }, 500)
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    async enableRule(row) {
      const { code, data } = await modifyDivideRuleStateSignCheck({
        ruleId: row.ruleId,
        state: 1,
      })
      if (code === 1) {
        if (data) {
          this.$message.success('启用成功')
        } else {
          this.$message.error('启用失败')
        }
        this.$refs.baseListManagement.searchForm()
      }
    },
    async submitConfirmHandle() {
      try {
        this.ruleConfirmDialog.loading = true
        const { code, data } = await modifyDivideRuleStateSignCheck({
          ruleId: this.ruleConfirmDialog.ruleId,
          state: this.ruleConfirmDialog.state,
        })
        if (code === 1) {
          if (data.result) {
            this.$message.success('停用成功')
          } else {
            this.$message.error(data.info)
          }
          this.ruleConfirmDialog.show = false
          this.ruleConfirmDialog.loading = false
          this.$refs.baseListManagement.searchForm()
        }
      } catch (error) {
        this.ruleConfirmDialog.loading = false
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    callManualDivideDialog(row) {
      this.manualDivideDialog = {
        show: true,
        ruleId: row.ruleId,
        transferorName: row.transferorName,
        receiverName: row.receiverName,
        divideAmount: row.divideAmount,
        loading: false,
      }
    },
    async submitManualDivide() {
      this.manualDivideDialog.loading = true
      try {
        const { code, data } = await applyDivide({
          ruleId: this.manualDivideDialog.ruleId,
          channelType: this.bankChannelType,
        })
        this.manualDivideDialog.loading = false
        if (code === 1) {
          this.manualDivideDialog.show = false
          if (data.result) {
            this.$message.success('转账成功')
          } else {
            this.$message.error(data.info)
          }
          this.$refs.baseListManagement.searchForm()
        }
      } catch (error) {
        this.manualDivideDialog.loading = false
      }
    },
  },
  computed: {
    ...mapGetters(['bankChannelType']),
    getAddRulePermission() {
      return this.checkBankChannelPermission('addTransferRulesConfig', 'addTransferRulesConfigWangshang', this.bankChannelType)
    },
  },
  mounted() {
    this.configData.formData.formProps.model.channelType = this.bankChannelType

    // 如果有ruleId需要携带到搜索里
    if (this.$route.query.ruleId) {
      this.configData.formData.formProps.model.ruleId = this.$route.query.ruleId
    }

    // 转出方：1，接收方：2
    this.getReceiverAndTransferAccountList([1, 2])
  },
  watch: {
    bankChannelType: {
      handler(val) {
        this.configData.formData.formProps.model.channelType = val
        // 转出方：1，接收方：2
        this.getReceiverAndTransferAccountList([1, 2])
      },
    },
  },
}
</script>
